import styled from "styled-components";

import {
	FONT_WT_MEDIUM,
	COLOR_WHITE,
	COLOR_BLACK,
	COLOR_JAVA_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	TABLET_M_BP,
	MOBILE_L_BP,
	MOBILE_SM_BP,
	COLOR_NOBEL_GREY,
	COLOR_DARK_RED,
	COLOR_BORDER_INPUT,
	FONT_WT_HEAVY,
	COLOR_LEAF_GREEN,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
	padding-top: 120px;
	padding-bottom: 60px;
	${({ desktopBgImageUrl }) =>
		desktopBgImageUrl &&
		`
      background-image: url(${desktopBgImageUrl});
      background-size: contain;
  `}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		flex-direction: column;
		padding-top: 70px;
		padding-left: 10px;
		padding-right: 10px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		${({ mobileBgImageUrl }) =>
			mobileBgImageUrl &&
			`
      background-image: url(${mobileBgImageUrl});
      background-size: contain;
    `}
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		gap: 24px;
		justify-content: center;
	}
	.image-wrapper {
		text-align: center;

		& img {
			max-width: 100%;
		}

		@media only screen and (max-width: ${TABLET_M_BP}px) {
			grid-row: 1;
			margin-bottom: 16px;
		}
	}
`;

export const CodeBox = styled.div`
	background: ${COLOR_WHITE};
	border: 1px dashed ${COLOR_JAVA_LIGHT};
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px 12px;
	height: 54px;
	gap: 8px;
	width: fit-content;

	.invite-link {
		color: var(--primary-neutral-nightshade-600);
		font-weight: 500;

		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			font-size: 10px;
		}
	}

	.referral-code {
		margin-right: 32px;
		color: var(--secondary-gray-dark);
	}
`;

export const CopyIcon = styled.span`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 16px;
	line-height: 19px;
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: auto;
	margin-bottom: auto;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	white-space: nowrap;
	img {
		margin-right: 4px;
		width: 25px !important;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 10px;

		img {
			margin-right: 2px;
			width: 16px !important;
		}
	}
`;

export const SocialShare = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 30px;
	gap: 24px;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		gap: 8px;
	}
`;

export const SocialMedia = styled.div`
	margin-left: 6px;
	margin-right: 6px;
	img {
		height: 48px;
		width: 48px;
		@media only screen and (max-width: ${TABLET_M_BP}px) {
			height: 40px;
			width: 40px;
		}
	}
`;

export const OverlappingCardWrapper = styled.div`
	background: ${({
		topBackgroundColor = "var(--primary-green-100)",
		bottomBackgroundColor = "var(--primary-neutral-white)",
	}) =>
		`linear-gradient(180deg, ${topBackgroundColor}  0 calc(50% - 2.5rem), ${bottomBackgroundColor}  calc(50% - 2.5rem) 100%)`};
	padding-bottom: 80px;

	.card-container {
		padding: 3rem 4rem;
		display: flex;
		flex-direction: column;
		gap: 32px;
		background: ${({
			contentBackgroundColor = "var(--primary-neutral-white)",
		}) => contentBackgroundColor};
		color: ${({ isDarkBackground }) =>
			isDarkBackground
				? "var(--primary-neutral-white)"
				: "var(--primary-neutral-nightshade-800)"};
		.description-wrapper {
			color: ${({ isDarkBackground }) =>
				isDarkBackground
					? "var(--primary-neutral-white)"
					: "var(--primary-neutral-nightshade-600)"};
			.description {
				margin: 1rem 0;
			}
		}
		.media-grid-margin {
			margin: 0px 40px;
		}
		& img {
			width: 100%;
		}
		& > div {
			margin: 0;
			align-self: center;
		}
		.media-container img {
			width: 100%;
			border-radius: 0.5rem;
		}
	}
	.link svg > path {
		fill: ${({ isDarkBackground }) =>
			isDarkBackground
				? "var(--secondary-purple-100)"
				: "var(--secondary-purple-300)"};
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding-bottom: 40px;
		.grid-container {
			margin: 0 1.5rem;
		}
		.card-container {
			padding: 2.5rem 1.5rem;
		}
	}

	//To display line graphic
	position: relative;
	contain: paint;
`;

export const FormContainer = styled.div`
	background-color: var(--primary-forest-600);
`;

export const Form = styled.div`
	max-width: 522px;
	padding: 40px 60px 40px 60px;
	margin: auto;
	text-align: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.input {
			margin-right: 0px !important;
		}
		input {
			width: 100% !important;
		}
		padding: 40px 30px 40px 30px;
	}

	.invite-form-title {
		color: var(--primary-neutral-white);
		margin-bottom: 24px;
	}

	.invite-form-description {
		color: var(--primary-neutral-white);
		margin-bottom: 16px;
	}

	.hs-form {
		padding-bottom: 30px;
		.hs-form-field {
			margin-bottom: 10px;
			text-align: left;
			font-size: 13px;
			color: #ffffff;
			&.hs-error-msgs {
				margin-bottom: 0px;
			}
			.input {
				.hs-input {
					width: 100%;
					height: 50px;
					border-radius: 3px;
					box-shadow: 0 9px 20px 0 rgba(0, 0, 0, 0.05);
					border: solid 1px ${COLOR_BORDER_INPUT};
					background-color: ${COLOR_WHITE};
					color: ${COLOR_NOBEL_GREY};
					padding-left: 10px;
					padding-right: 10px;
					::placeholder {
						color: ${COLOR_NOBEL_GREY};
						opacity: 1;
					}
				}
				.error {
					border: 1px solid ${COLOR_DARK_RED};
				}
			}
		}
	}
	.hs-fieldtype-date {
		text-align: left;
		label {
			padding-left: 30px;
			font-size: 12px;
			color: ${COLOR_NOBEL_GREY};
		}
	}
	.actions {
		margin: 0;
		padding: 12px 0;
		text-align: center;
	}
	.hs-button {
		width: 99%;
		color: var(--secondary-purple-300);
		font-weight: ${FONT_WT_HEAVY};
		font-size: 18px;
		height: 50px;
		background-color: var(--secondary-purple-100);
		border: 1px solid var(--secondary-purple-100);
		border-radius: 3px;
		padding-left: 30px;
		padding-right: 30px;
		cursor: pointer;
		:hover {
			background: var(--secondary-purple-50);
			border: 1px solid var(--secondary-purple-50);
		}
		:focus {
			border: none;
			box-shadow: none;
		}
		${(p) =>
			p.darkBg
				? `
      color: var(--secondary-purple-300);
      background-color: var(--secondary-purple-100);
      border: 1px solid  var(--secondary-purple-100);
      :hover {
        background: var(--secondary-purple-50);
        border: 1px solid var(--secondary-purple-50);
      }
    `
				: null}
	}
	.hs-error-msgs {
		color: ${COLOR_DARK_RED};
		list-style: none;
		margin: 0px;
		padding: 0px;
		font-size: 11px;
		line-height: 11px;
		text-align: left;
	}
	.hs-field-desc {
		display: none !important;
	}
	input:focus,
	textarea:focus,
	select:focus {
		outline: none;
		box-shadow: 0 0 5px ${COLOR_LEAF_GREEN};
		border: 1px solid ${COLOR_BLACK};
	}
	.hs-form-required {
		display: none;
	}
	.hs-richtext {
		h2 {
			padding-top: 15px;
			font-size: 18px;
			font-weight: ${FONT_WT_MEDIUM};
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
	}
`;
